import { withRouter, useParams, useHistory } from 'react-router-dom'
import { Grid, Paper } from '@material-ui/core'
import OrderDetails from './OrderDetails'

const OrderDetailsView = () => {
  const { orderNumber, level } = useParams()
  let history = useHistory()
  const goBack = () => {
    history.push('/orders')
  }
  return (
    <Paper style={{ padding: 16 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <OrderDetails
            orderNumber={orderNumber}
            level={level}
            onClose={goBack}
            cancelLabel="Atras"
          />
        </Grid>
      </Grid>
    </Paper>
  )
}

export default withRouter(OrderDetailsView)
OrderDetailsView.displayName = 'Detalle de pedido'
